import useSite from '../hooks/useSite';

export const StatusBanner = ({ status, className }: { status: string; className?: string }) => {
  const [site] = useSite();

  const friendlyStatus =
    status === 'available'
      ? site?.statuslabels?.available
      : status === 'sold'
        ? site?.statuslabels?.sold
        : status === 'extra'
          ? site?.statuslabels?.extra
          : site?.statuslabels?.reserved;

  const statusClass =
    status === 'available'
      ? 'status-available'
      : status === 'sold'
        ? 'status-sold'
        : status === 'extra'
          ? 'status-extra'
          : 'status-pending';

  return (
    <div className={`status-popup-shape ${statusClass} flex items-center font-bold text-white ${className}`}>
      {friendlyStatus}
    </div>
  );
};
